// hooks/useLocalization.js
import { useTranslation } from "react-i18next";

const useLocalization = () => {
  const { t, i18n } = useTranslation();

  return {
    t,
    setLanguage: (lng) => i18n.language !== lng && i18n.changeLanguage(lng),
    getLanguage: () => i18n.language,
  };
};

export default useLocalization;
